import {EntityField} from "../../core/genericdocuments/EntityField"
import {EntityFieldDataType} from "../../core/genericdocuments/EntityFieldDataType"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {Category} from "../../models/Category"

export const categoryFields: IntercateKeysMap<Category, EntityField<Category>> = {
    id: {
		name: "id", dataType: EntityFieldDataType._string, label: "Id kategorije",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    title: {
		name: "title", dataType: EntityFieldDataType._string, label: "Naziv kategorije",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    description: {
		name: "description", dataType: EntityFieldDataType._string, label: "Opis kategorije",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
}

const categoryFieldsArray: Array<EntityField<Category>> = [
	categoryFields.title,
	categoryFields.description,
]

export const categoryFieldsDescriptor: EntityFieldsDescriptor<Category> = {
	listFields: categoryFieldsArray,
	createFormFields: categoryFieldsArray,
	updateFormFields: categoryFieldsArray
}